export const withAPIKey = (url: string): string =>  `${url}?api_key=${process.env.API_KEY}`